module.exports = __webpack_public_path__ + "img/martha-coffin-wright.4aa66cc9.png";